/** Normalized API failure. Matches the backend's { error: { message, code } }. */
export class ApiError extends Error {
  readonly status: number;
  readonly code: string;

  constructor(message: string, status: number, code: string) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.code = code;
  }
}

export const isForbidden = (error: unknown): boolean =>
  error instanceof ApiError && error.status === 403;
